module.exports = __webpack_public_path__ + "static/media/fun-fact-bg.34c6010a.jpg";